'use client';

import { FC } from 'react';

import { User } from '@ravago/shared/authentication';
import { NormalizedUnitOfMeasure } from '@ravago/shared/page-data/models/contentful-mapped';
import { RelatedDocument } from '@ravago/shared/page-data/models/elements';
import { Box } from '@ravago/shared/radiance/components/box/components/Box/Box';
import { DownloadOption } from '@ravago/shared/radiance/components/input-field/components/Download/Download';

import DocumentListItemBody from './document-list-item-body';

interface Props {
   document: RelatedDocument;
   locale: string;
   hasSharePermission?: boolean;
   sharedDocument: boolean;
   onDocumentDownload: (document: RelatedDocument, selectedLanguageId?: string, selectedUOMId?: string) => void;
   onViewDocument: (document: RelatedDocument, selectedLanguageId?: string, selectedUOMId?: string) => void;
   onShareChecked: (document: RelatedDocument) => void;
   onLanguageChange?: (lan: DownloadOption | undefined) => void;
   onUOMChange?: (uom: DownloadOption | undefined) => void;
   selectedLanguage?: DownloadOption;
   selectedUOM?: DownloadOption;
   availableLanguages: DownloadOption[];
   channelUOMs: Array<NormalizedUnitOfMeasure>;
   user?: User;
   detailPageName?: string;
   ulProspectorId: string | undefined;
   language: string;
   publicShowTdsUom: boolean;
   showTdsUom: boolean;
   canDownloadDocumentsAnonymously?: boolean;
   canDownloadDocument: boolean;
   superCondensedView: boolean;
   condensedView: boolean;
}

const DocumentListItem: FC<Props> = ({
   document,
   user,
   hasSharePermission,
   sharedDocument,
   language,
   selectedLanguage,
   selectedUOM,
   onDocumentDownload,
   onViewDocument,
   onLanguageChange,
   onUOMChange,
   availableLanguages,
   onShareChecked,
   ulProspectorId,
   detailPageName,
   locale,
   channelUOMs,
   publicShowTdsUom,
   showTdsUom,
   canDownloadDocumentsAnonymously,
   canDownloadDocument,
   superCondensedView,
   condensedView
}) => {
   const isAuthenticated = !!user || !!canDownloadDocumentsAnonymously;

   return (
      <Box direction="column">
         <DocumentListItemBody
            locale={locale}
            onShareChecked={onShareChecked}
            sharedDocument={sharedDocument}
            document={document}
            superCondensedView={superCondensedView}
            condensedView={condensedView}
            ulProspectorId={ulProspectorId}
            onLanguageChange={onLanguageChange}
            onUOMChange={onUOMChange}
            onDocumentDownload={() => onDocumentDownload(document, selectedLanguage?.id, selectedUOM?.id)}
            onViewDocument={() => onViewDocument(document, selectedLanguage?.id, selectedUOM?.id)}
            availableLanguages={availableLanguages}
            channelUOMs={channelUOMs}
            detailPageName={detailPageName}
            publicShowTdsUom={publicShowTdsUom}
            showTdsUom={showTdsUom}
            isAuthenticated={isAuthenticated}
            hasSharePermission={hasSharePermission}
            selectedUOM={selectedUOM}
            selectedLanguage={selectedLanguage}
            language={language}
            user={user}
            canDownloadDocument={canDownloadDocument}
         />
      </Box>
   );
};

export default DocumentListItem;
